import createImageUrlBuilder from "@sanity/image-url";
import { createClient } from "next-sanity";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import Item from "SanityComponents/CreditImmobilierComponents/ActionElement/Item";
import CreditImmobilerHeader from "SanityComponents/CreditImmobilierComponents/CreditImmobilier";
import FAQ from "SanityComponents/FAQ/FAQ";
import Footer from "SanityComponents/Footer/Footer";
import Feedback from "SanityComponents/OffersPro/FeedBack/Feadback";
import Ourplans from "SanityComponents/OffersPro/Ourplans/Ourplans";
import Question from "SanityComponents/Question/Question";
import SubHeader from "SanityComponents/SubHeader/SubHeader";
import SanityHeadSeo from "../sanity/Components/SanityHeadSeo/SanityHeadSeo";
import style from "./style.module.css";
import WhatssapComponent from "SanityComponents/WhatssapComponent";
import formatUrl from "utils/FormatUrl";

const client = createClient({
  apiVersion: "2023-01-01",
  dataset: "production" || "production",
  projectId: "n2i0cmq4" || "",
  useCdn: false,
});
function urlFor(source) {
  return createImageUrlBuilder(client).image(source);
}

export default function OffersPro({ data }: { data: any }) {
  const { t, lang } = useTranslation("common");

  return (
    <div className={style.header}>
      {data?.content.map((item, key) => {
        if (item._type == "lpheader") {
          return (
            <div key={key}>
              <CreditImmobilerHeader
                title={item.titre ? item.titre[lang] : ""}
                subtitle={item.soustitre ? item.soustitre[lang] : ""}
                secsubtitle={
                  item.secondsoustitre ? item.secondsoustitre[lang] : ""
                }
                buttonText={item.button ? item.button[lang] : ""}
                button_link={formatUrl(
                  `https://www.agenz.ma/${lang}${item.button_link}`,
                  lang
                )}
                overlay={item.overlay_image}
                content={item.content}
                backgroundUrl={urlFor(item.background_image)
                  .format("webp")
                  .auto("format")
                  .fit("clip")
                  .toString()}
                offersPro={true}
              />
            </div>
          );
        } else if (item._type == "WhatssapComponent") {
          return (
            <WhatssapComponent
              number={item?.numberPhone ? item.numberPhone : null}
              message={item?.message ? item.message[lang] : null}
            />
          );
        } else if (item._type == "SanityHeadSeo") {
          return (
            <div key={key}>
              <SanityHeadSeo
                title={item.titre ? item.titre[lang] : ""}
                ogTitle={item.titre ? item.titre[lang] : ""}
                description={item.description ? item.description[lang] : ""}
                ogDescription={item.description ? item.description[lang] : ""}
                canonicalUrl={item.canonicalUrl}
                ogTwitterImage={
                  item.mainImage
                    ? urlFor(item.mainImage)
                        .width(250)
                        .height(250)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()
                    : null
                }
                ogType={item.ogType}
                ogImageUrl={
                  item.mainImage
                    ? urlFor(item.mainImage)
                        .width(250)
                        .height(250)
                        .format("webp")
                        .auto("format")
                        .fit("clip")
                        .auto("format")
                        .toString()
                    : null
                }
                structuredData={null}
              >
                <></>
              </SanityHeadSeo>
            </div>
          );
        } else if (item._type == "SubHeader") {
          return (
            <div key={key}>
              <SubHeader
                title={item.titre ? item.titre[lang] : ""}
                subTitle={item.subTitle[lang]}
              />
            </div>
          );
        } else if (item.OffreProComponent?.length > 1) {
          return (
            <div key={key}>
              <div className={style.actionElements}>
                {item.OffreProComponent.map((element, ind) => {
                  return (
                    <div key={ind}>
                      <Item
                        title={element.titre ? element.titre[lang] : ""}
                        image={urlFor(element.mainImage)
                          .format("webp")
                          .auto("format")
                          .fit("clip")
                          .auto("format")
                          .toString()}
                        width={element.width ? element.width : element.width}
                        height={
                          element.height ? element.height : element.height
                        }
                        description={element.text[lang]}
                        buttonText={element.button_text[lang]}
                        button_link={formatUrl(
                          `https://www.agenz.ma/${lang}/${element.button_link}`,
                          lang
                        )}
                        offersPro={true}
                        index={ind % 2}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        } else if (item._type === "OffersProPlans") {
          return (
            <div key={key}>
              <div className={style.planPro}>
                <p className={style.planProTitle}>
                  {item.titre ? item.titre[lang] : ""}
                </p>
                <div className={style.planCards}>
                  {item.plancards?.map((element, index) => {
                    return (
                      <div key={index}>
                        <Ourplans
                          title={element.titre ? element.titre[lang] : ""}
                          subTitle={element.subtitre[lang]}
                          planinfos={element.planinfos}
                          button_title={element.titre_button[lang]}
                          btn_link={element.button_link}
                          lang={lang}
                          isFirst={index === 0}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        } else if (item._type == "FeadBack") {
          return (
            <div key={key}>
              <div className={style.feedback}>
                <Feedback feadback={item.FeadBack} lang={lang} />
              </div>
            </div>
          );
        } else if (item._type == "QuestionImmobilier") {
          return (
            <div key={key}>
              <div>
                <Question
                  title={item.titre ? item.titre[lang] : ""}
                  text={item.text ? item.text[lang] : ""}
                  buttonText={item.button_text ? item.button_text[lang] : ""}
                  image={urlFor(item.mainImage)
                    .format("webp")
                    .auto("format")
                    .fit("clip")
                    .auto("format")
                    .toString()}
                  button_link={item.button_link}
                />
              </div>
            </div>
          );
        } else if (item._type == "Faq") {
          return (
            <div key={key}>
              <FAQ data={item} lang={lang} />
            </div>
          );
        } else if (item._type == "SanityFooter") {
          return (
            <div key={key}>
              <div className={style.footer}>
                <div className={style.footerDesk}>
                  <Footer
                    propos={item.propos[lang]}
                    proposText={item.text ? item.text[lang] : ""}
                    donnee={item.donnees[lang]}
                    donneeText={item.textdonnee[lang]}
                    technologie={item.technologie[lang]}
                    technologieText={item.texttechnologies[lang]}
                    logo={urlFor(item.agenz_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    facebook={urlFor(item.facebook_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    instagram_logo={urlFor(item.instagram_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    linked_in={urlFor(item.linkedin_logo)
                      .format("webp")
                      .auto("format")
                      .fit("clip")
                      .auto("format")
                      .toString()}
                    socialMediaText={item.socialMediatext}
                    copyRightText={item.permission_text}
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
